import fields from '../Field.constants';
import { onHold } from 'Common/Utils/regexPatterns';

const getPatchUpdate = updates => updates.reduce(applyPatch, initial);

const initial = [];

const applyPatch = (patch, update) => {
    if (update.field === fields.ReadyForApproval && onHold.test(update.value)) {
        return [...patch, patchField(update), patchField({ field: fields.ContractReleaseDate, value: null })];
    }
    return [...patch, patchField(update)];
};

const patchField = update => ({
    path: patchPaths[update.field],
    op: 'replace',
    value: update.value
});

const patchPaths = {
    [fields.Template]: '/Template',
    [fields.ReadyForApproval]: '/ReadyForApproval',
    [fields.ContractReleaseDate]: '/Contract/ReleaseDate',
    [fields.ContractEndDate]: '/Contract/EndDate',
    [fields.TeamEmail]: '/TeamEmail',
};

export default getPatchUpdate;